import React, { useEffect } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import { useDispatch } from "react-redux";

// Design system first (tokens, reset, shared UI), then one file per area.
import "styles/tokens.css";
import "styles/base.css";
import "styles/ui.css";
import "styles/app.css";
import "styles/auth.css";
import "styles/classes.css";
import "styles/player.css";

import MemberRoute from "components/routes/MemberRoute";
import GuestRoute from "components/routes/GuestRoute";

import NotFound from "pages/404";
import Unauthenticated from "pages/401";

import Login from "pages/Login";
import Logout from "pages/Logout";
import Register from "pages/Register";

import MyClass from "pages/MyClass";
import Joined from "pages/Joined";
import Player from "pages/Player";
import { Profile, Password } from "pages/Settings";
import Transactions from "pages/Transactions";

import { usersApi as users } from "api";
import { setUserCookie, clearUserCookie } from "lib/userCookie";

import { populateProfile, signedOut } from "store/actions/users";

function App() {
  const dispatch = useDispatch();
  const history = createBrowserHistory({ basename: process.env.PUBLIC_URL });

  // Who is signed in comes from the API's session cookie. The routes wait
  // for this answer before deciding between the page and the login.
  useEffect(() => {
    users
      .me()
      .then((res) => {
        dispatch(populateProfile(res.data));
        // Lets the public site (class.youwdin.com) show the account menu.
        setUserCookie({ name: res.data.name, thumbnail: res.data.avatar });
      })
      .catch(() => {
        dispatch(signedOut());
        clearUserCookie();
      });
  }, [dispatch]);
  return (
    <>
      <Router history={history}>
        <Switch>
          <GuestRoute path="/login" component={Login}></GuestRoute>
          <Route path="/logout" component={Logout}></Route>
          <GuestRoute path="/register" component={Register}></GuestRoute>
          <GuestRoute path="/private" component={Unauthenticated}></GuestRoute>

          <MemberRoute exact path="/" component={MyClass}></MemberRoute>
          <MemberRoute
            exact
            path="/joined/:class"
            component={Joined}
          ></MemberRoute>

          <MemberRoute
            exact
            path="/courses/:class/:chapter/:uid"
            component={Player}
          ></MemberRoute>
          <MemberRoute
            exact
            path="/courses/:class/"
            component={Player}
          ></MemberRoute>
          <MemberRoute exact path="/settings" component={Profile}></MemberRoute>
          <MemberRoute exact path="/settings/password" component={Password}></MemberRoute>
          <MemberRoute
            path="/transactions"
            component={Transactions}
          ></MemberRoute>

          <Route path="*" component={NotFound}></Route>
        </Switch>
      </Router>
    </>
  );
}

export default App;
